import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GlobalStylesUTCom } from '@unitedtraders/utcom-ui-kit';
import { Header } from '../../components/Header';
import { SideMenu } from '../../components/SideMenu';

export class Layout extends Component {
  static contextTypes = { readiness: PropTypes.object.isRequired };

  state = { isMenuVisible: false };

  componentWillMount() {
    this.context.readiness.ready(this);
  }

  render() {
    const { isMenuVisible } = this.state;
    return (
      <div className="container">
        <div className="wrapper">
          <Header openSideMenu={() => this.setState({ isMenuVisible: !isMenuVisible })} />
          <SideMenu
            isVisible={isMenuVisible}
            setIsVisible={isMenuVisible => this.setState({ isMenuVisible })}
          />
          {this.props.children}
        </div>
        <GlobalStylesUTCom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/layout/Layout.js